export default __webpack_public_path__ + "media/images/theme/m_logo_dark_backup-228d5ec045cf94a5366f224955fb8ea1.png";